var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.d{fill:#606060;}.c,.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1024 -663)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1024 663)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2,0h9a2,2,0,0,1,2,2v9a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 2 1.5 C 1.724300384521484 1.5 1.5 1.724300384521484 1.5 2 L 1.5 11 C 1.5 11.27569961547852 1.724300384521484 11.5 2 11.5 L 11 11.5 C 11.27569961547852 11.5 11.5 11.27569961547852 11.5 11 L 11.5 2 C 11.5 1.724300384521484 11.27569961547852 1.5 11 1.5 L 2 1.5 M 2 0 L 11 0 C 12.10457038879395 0 13 0.8954296112060547 13 2 L 13 11 C 13 12.10457038879395 12.10457038879395 13 11 13 L 2 13 C 0.8954296112060547 13 0 12.10457038879395 0 11 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930.348 580.291) rotate(40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.799)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.569,2.083a2.407,2.407,0,0,0-4.77,0V6.991a1.44,1.44,0,0,0,.523,1.1,1.877,1.877,0,0,0,1.23.442,1.658,1.658,0,0,0,1.753-1.538V2.628a.93.93,0,0,0-.336-.711,1.258,1.258,0,0,0-1.572,0,.932.932,0,0,0-.336.714V6.445a.492.492,0,0,0,.981,0V2.628a.083.083,0,0,1,.032-.063.19.19,0,0,1,.219,0,.083.083,0,0,1,.031.061V6.991a.786.786,0,0,1-1.546,0V2.083a1.424,1.424,0,0,1,2.809,0V5.9a.492.492,0,0,0,.981,0V2.083Z",
    transform: "translate(-131.799)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSend);
export default __webpack_public_path__ + "static/media/file-send.010421fe5c75cc6f2bfadafb326350d4.svg";
export { ForwardRef as ReactComponent };